/**
 * Delete all cookies by setting their expiration date to the past
 */
export const deleteAllCookies = (): void => {
  const cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()

    // Delete cookie with different path and domain combinations
    // Path: root
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    
    // Path: current path
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${window.location.pathname}`
    
    // Domain: current domain
    const domain = window.location.hostname
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`
    
    // Domain: parent domain (if subdomain)
    const domainParts = domain.split('.')
    if (domainParts.length > 2) {
      const parentDomain = `.${domainParts.slice(-2).join('.')}`
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${parentDomain}`
    }
  }
}

/**
 * Delete a specific cookie by name
 */
export const deleteCookie = (name: string): void => {
  // Delete cookie with different path and domain combinations
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${window.location.pathname}`
  
  const domain = window.location.hostname
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`
  
  const domainParts = domain.split('.')
  if (domainParts.length > 2) {
    const parentDomain = `.${domainParts.slice(-2).join('.')}`
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${parentDomain}`
  }
}

/**
 * Get all cookie names
 */
export const getAllCookieNames = (): string[] => {
  const cookies = document.cookie.split(';')
  return cookies
    .map((cookie) => {
      const eqPos = cookie.indexOf('=')
      return eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()
    })
    .filter((name) => name.length > 0)
}
